import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { applyDocumentLanguage, normalizeLanguageCode } from "./languages";

/**
 * Keeps document.documentElement.lang / .dir in sync with the active i18n language.
 * Mounted once at the app shell (DocumentDirectionSync) — do not duplicate in Chat pages.
 */
export function useDocumentDirection() {
  const { i18n } = useTranslation();
  const effectiveLanguage = i18n.resolvedLanguage || i18n.language;

  useEffect(() => {
    const lang = normalizeLanguageCode(effectiveLanguage) ?? "en";
    applyDocumentLanguage(lang, effectiveLanguage);
  }, [effectiveLanguage]);
}
